import { Button, Card, CardBody } from '@material-tailwind/react';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { tokenState } from '@/atom/tokenState.jsx';
import AccordianEditComponent from '@/StyledUIComponent/AccordianEditComponent.jsx';
import TitleDesInputComponent from '@/styledUIComponent/TitleDesInputComponent.jsx';
import { getFaqs } from '@/api/faqApi.jsx';
import PageHeader from '@/components/common/PageHeader';
import { FaQuestionCircle } from 'react-icons/fa';

const FAQPage = () => {
  const [open, setOpen] = useState(0);
  const [create, setCreate] = useState(false);
  const [data, setData] = useState([]);
  const { accessToken } = useRecoilValue(tokenState);

  const handleOpen = (index) => {
    if (index === open) setOpen(0);
    else setOpen(index);
  };

  const fetchFaqs = () => {
    getFaqs()
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error('FAQ 데이터를 가져오는데 실패했습니다:', err);
      });
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="lg:max-w-[75rem] 2xl:max-w-layout mx-auto font-notoSans sm:px-8 lg:p-0 lg:mt-[2rem]">
      <PageHeader
        icon={FaQuestionCircle}
        title="자주 묻는 질문"
        bannerImage={
          isMobile ? '/images/main/main_02 6.jpg' : '/images/banner/banner5.png'
        }
      />
      <div className="w-full flex justify-center">
        <Card className="max-w-[100rem] w-full min-h-[40vh] shadow-none">
          <CardBody>
            {accessToken && (
              <div className="w-full">
                <div className="flex justify-end">
                  <Button onClick={() => setCreate(!create)}>Create</Button>
                </div>
              </div>
            )}
            {accessToken && create ? (
              <TitleDesInputComponent
                handleCancel={() => setCreate(!create)}
                refreshFaqs={fetchFaqs}
              />
            ) : null}
            {data.map((item, index) => (
              <AccordianEditComponent
                item={item}
                key={index}
                index={index}
                open={open}
                handleOpen={handleOpen}
                accessToken={accessToken}
                refreshFaqs={fetchFaqs}
              />
            ))}
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default FAQPage;
